export enum ProgramChecklistTypeEnum {
    AcknowldgeFieldSupervisorObservation = 35
}